import { FC, useEffect, useRef, useState } from "react";
import { KTSVG } from "../../../_metronic/helpers";
import Swal from "sweetalert2";
import useAccessToken from "../../../hooks/AccessToken";
import { TemplatePipelineProps } from '../../../interfaces/Pipeline';
import { useIntl } from "react-intl";
import { deleteTemplatePipeline } from "../../../api/PipelineCRUD";
import { useTemplatePipeline } from "../../../stores/TemplatePipeline";
import { Modal } from "rsuite";

interface Props {
    type: string
    template: TemplatePipelineProps
    reset: () => void
    isOpen: boolean
    onClose: () => void
}

const DeleteTemplatePipeline: FC<Props> = ({ type, template, reset, isOpen, onClose }) => {
    const token = useAccessToken()
    const { userTemplatePipeline, companyTemplatePipeline, setUserTemplatePipeline, setCompanyTemplatePipeline } = useTemplatePipeline()
    const [modalBtnLoading, setModalBtnLoading] = useState(false)
    const intl = useIntl()

    const handleDeletePipeline = async () => {
        setModalBtnLoading(true)

        try {
            const response = await deleteTemplatePipeline(template.id, token)
            if (response.data.success) {
                if (template.content.use) reset()

                Swal.fire({
                    icon: 'success',
                    heightAuto: false,
                    title: `${intl.formatMessage({ id: "FORM.VALIDATION.DELETE_SUCCESS" })}`,
                    timer: 2000,
                    timerProgressBar: true
                })

                onClose()
                if (type === 'delete-template-user') setUserTemplatePipeline(userTemplatePipeline.filter(item => item.id !== template.id));
                else if (type === 'delete-template-company') setCompanyTemplatePipeline(companyTemplatePipeline.filter(item => item.id !== template.id));
            }
        } catch (error: any) {
            Swal.fire({
                icon: 'error',
                title: error.response.data.message,
                confirmButtonText: 'Ok'
            })
        } finally {
            setModalBtnLoading(false)
        }
    }

    useEffect(() => {
        const getRsModalWrapper: HTMLDivElement | null = document.querySelector('.rs-modal-wrapper')
        if (getRsModalWrapper) {
            getRsModalWrapper.style.display = 'flex'
            getRsModalWrapper.style.alignItems = 'center'
            getRsModalWrapper.style.justifyContent = 'center'
        }
    }, [])

    return (
        <Modal
            backdrop={true}
            keyboard={false}
            open={isOpen}
            onClose={onClose}
            size="sm"
        >
            <Modal.Header>
                <h5 className="modal-title">{intl.formatMessage({ id: "FORM.ACTION.DELETE" })} {template.name}</h5>
            </Modal.Header>
            <Modal.Body>
                <p>{intl.formatMessage({ id: 'FORM.CONFIRMATION' })} {intl.formatMessage({ id: 'FORM.ACTION.DELETE' }).toLowerCase()} {template.name}?</p>
            </Modal.Body>
            <Modal.Footer>
                <button
                    type="button"
                    className="btn btn-light me-3"
                    onClick={onClose}
                >
                    {intl.formatMessage({ id: "FORM.ACTION.CANCEL" })}
                </button>
                <button type="button" onClick={handleDeletePipeline} className={`btn btn-danger me-10 ${modalBtnLoading ? "disabled" : ""}`} data-kt-indicator={modalBtnLoading ? 'on' : 'off'}>
                    <span className="indicator-label">
                        {intl.formatMessage({ id: "FORM.ACTION.DELETE" })}
                    </span>
                    <span className="indicator-progress">
                        Loading... <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </span>
                </button>
            </Modal.Footer>
        </Modal>
    )
}

export { DeleteTemplatePipeline }